import config from "../../config";

const checkCancelEligibility = async (
  hotelId,
  bookingId,
  setCancelEligibilityData,
  setEligibilityLoader
) => {
  let token = sessionStorage.getItem("token");

  try {
    let response = await fetch(
      config.beAlphaEndpoint + "check-cancel-eligibility",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          hotel_id: hotelId,
          booking_id: bookingId,
        }),
      }
    );

    let responseJson = await response.json();

    setCancelEligibilityData({
      is_cancellable: !!responseJson.is_cancellable,
      is_partial_cancellable: !!responseJson.is_partial_cancellable,
      message: responseJson.message || "",
      status: responseJson.status,
    });

    setEligibilityLoader(false);
  } catch (error) {
    setCancelEligibilityData({
      is_cancellable: false,
      is_partial_cancellable: false,
      message: "Something went wrong",
      status: 0,
    });
    setEligibilityLoader(false);
  }
};

export default checkCancelEligibility;
